import { LayoutCard, LayoutCardProps } from '@cast/design-system';

export type WidgetLayoutProps = LayoutCardProps;

export const WidgetLayout = ({ sx, ...rest }: WidgetLayoutProps) => (
  <LayoutCard {...rest} sx={{ height: '100%', ...(sx || {}) }} />
);
